import React from 'react';
import { XIcon } from 'lucide-react';
const pains = ['Half the group asleep, and the other half done in five minutes', 'Residents who can no longer read or talk much, and a game that needs both', "Planning tomorrow's activity at night, on your own time", 'A mixed-level room and an activity that fits only one of the levels', 'The kind of quiet where you can hear a pin drop', 'Being the only activities person, with nobody to share the load', 'Residents who stay in their rooms, and a 1:1 visit with nothing planned', 'Nursing asking if you are doing enough, and nothing in your hands to show them'];
export function PainGrid() {
  return <section aria-labelledby="pain-heading" className="w-full bg-plum" data-id="element-177" data-mp="1brnvrsas2sn1">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-178" data-mp="17ptyzv3pe8s5">
        <div className="text-center" data-id="element-179" data-mp="364dm601xtjpo">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-180" data-mp="363c43bmi7wyg">
            The part nobody plans for
          </p>
          <h2 id="pain-heading" className="mt-3 font-display font-bold text-white text-3xl sm:text-4xl md:text-5xl leading-tight" data-id="element-181" data-mp="3g9d1ztgndzxo">
            If you run activities in memory care, you know at least{' '}
            <span className="italic text-coral-soft" data-id="element-182" data-mp="379qb41ljociv">half of this list.</span>
          </h2>
        </div>

        <ul className="mt-9 grid gap-3 text-left sm:grid-cols-2 sm:gap-x-5" data-id="element-183" data-mp="3bas4i1ss5ucx">
          {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-2xl border border-plum-line bg-plum-card px-4 py-4 text-sm text-white/90" data-id="element-184" data-mp="2uyve80s3l5w">
              <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-coral/25" data-id="element-185" data-mp="3q6ritu6hgqqi">
                <XIcon className="h-3 w-3 text-coral-soft" aria-hidden="true" data-id="element-186" data-mp="3u71kiun8suzk" />
              </span>
              {pain}
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display italic text-2xl sm:text-3xl text-gold leading-tight" data-id="element-187" data-mp="qlm7l5hq8wy9">
          How many more afternoons do you want to spend improvising?
        </p>
      </div>
    </section>;
}